module.exports = __webpack_public_path__ + "static/img/背景.1007a98.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/背景.png
// module id = nRQr
// module chunks = 0